import React from 'react';
import styled from 'react-emotion';
import { ErrorMessage, Field } from 'formik';
import { ErrorSpan } from '../../Forms/Input';

const MeasurementContainer = styled('div')`
  width: calc(33% - 0.5rem);
  display: flex;
  flex-direction: column;
  border: 1px solid #b2b2b2;
  border-radius: 4px;
  overflow: hidden;
  margin: 0.5rem;
`;

const Image = styled('div')`
  width: 100%;
  padding-bottom: 100%;
  background-image: url(${p => p.src});
  background-size: contain;
  background-repeat: no-repeat;
`;

const MeasurementInput = styled('div')`
  display: flex;
  align-items: center;

  width: 100%;
  position: relative;
  border-top: 1px solid #b2b2b2;
  padding: 4px 4px;

  input {
    width: 100%;
    border: 0;
    padding-right: 4px;
    font-size: 1rem;
    text-align: right;
  }

  span {
    width: 24px;
    font-size: 1rem;
  }
`;

const Measurement = ({ src, name }) => (
  <MeasurementContainer>
    <Image src={src} />
    <Field
      id={name}
      name={name}
      render={({ field, form: { touched, errors } }) => (
        <MeasurementInput>
          <input {...field} type="text" />
          <span>cm</span>
        </MeasurementInput>
      )}
    />
    <ErrorMessage name={name} component={ErrorSpan} />
  </MeasurementContainer>
);

export default Measurement;
